<script>
  import {getContext} from 'svelte';
  import {numUtil} from '@/helper/num';
  import {TRADING_GAME} from '../images';
  import lang from '../TradeCompetitionPage.lang';

  export let title = '';
  export let ranks = [];
  export let rowItemCount = 3;

  const LG = getContext('LG');

  let ranksRows = [];

  $: updateRanksRows(ranks, rowItemCount);

  function updateRanksRows(ranks, rowItemCount) {
    const leftItems = [...ranks.slice(1)];
    ranksRows = [];
    while (leftItems.length > rowItemCount) {
      ranksRows.push(leftItems.splice(0, rowItemCount));
    }
    if (leftItems.length) {
      ranksRows.push(leftItems);
    }
  }
</script>

<style>
  .rank-item {
    display: flex;
    align-items: flex-end;
    box-sizing: border-box;
    border: 1px solid #192434;
    border-radius: 4px;
    padding: 12px;
    height: 80px;
    background: #0d131b;
    color: #fff;
  }
  .rank-mark {
    font-size: 36px;
    font-weight: bold;
    line-height: 42px;
    text-align: center;
  }
  .rank-detail {
    padding-left: 16px;
  }
  .participant-score {
    font-size: 14px;
    color: #1cc198;
  }
  .participant-name {
    padding-bottom: 12px;
    font-size: 16px;
    font-weight: bold;
    max-width: 120px;
  }
  .rank-value {
    flex: 1;
    text-align: right;
    font-size: 14px;
    font-weight: bold;
    white-space: nowrap;
  }
  .ranking-row {
    display: flex;
    justify-content: space-between;
    padding-bottom: 12px;
  }
  .ranking-row.first {
    justify-content: center;
  }
  .ranking-title {
    padding-top: 60px;
    padding-bottom: 56px;
    text-align: center;
    font-size: 32px;
    font-weight: bold;
    color: #fff;
  }
  .cup-img {
    position: relative;
    top: 8px;
    width: 64px;
    height: auto;
  }
  @media screen and (min-width: 640px) {
    .show-in-pc {
      display: block;
    }
    .rank-item {
      width: 392px;
    }
    .show-in-h5 {
      display: none;
    }
  }
  @media screen and (max-width: 640px) {
    .show-in-pc {
      display: none;
    }
    .rank-item {
      margin-bottom: 12px;
      width: 100%;
    }
    .show-in-h5 {
      display: block;
    }
    .ranking-title {
      padding-top: 40px;
      padding-bottom: 20px;
      font-size: 16px;
    }
  }
</style>

<div class="ranking-title">{title}</div>
<div class="show-in-pc">
  {#if ranks[0]}
    <div class="ranking-row first">
      <div class="rank-item">
        <div class="rank-mark">
          <img class="cup-img" src={TRADING_GAME.RANK_CUP} alt="cup image" />
        </div>
        <div class="rank-detail">
          <div class="participant-name">{ranks[0].name}</div>
          <div class="participant-score">
            {ranks[0].score}
          </div>
        </div>
        <div class="rank-value">
          {LG(lang.Prize)} : {ranks[0].prize}
        </div>
      </div>
    </div>
  {/if}
  {#each ranksRows as rankRow, rowIndex}
    <div class="ranking-row">
      {#each rankRow as rank, i}
        <div class="rank-item">
          <div class="rank-mark">{numUtil.pad(rowIndex * rowItemCount + (i + 2))}</div>
          <div class="rank-detail">
            <div class="participant-name">{rank.name}</div>
            <div class="participant-score">
              {rank.score}
            </div>
          </div>
          <div class="rank-value">
            {LG(lang.Prize)} : {rank.prize}
          </div>
        </div>
      {/each}
    </div>
  {/each}
</div>
<div class="show-in-h5">
  {#each ranks as rank, i}
    <div class="rank-item">
      <div class="rank-mark">{numUtil.pad(i + 1)}</div>
      <div class="rank-detail">
        <div class="participant-name">{rank.name}</div>
        <div class="participant-score">
          {rank.score}
        </div>
      </div>
      <div class="rank-value">
        {LG(lang.Prize)} : {rank.prize}
      </div>
    </div>
  {/each}
</div>
